<template>
  <div
    class="h-16 bg-seastreak-blue p-2 px-4 ecommerce-navbar ecommerce-navbar-background-color shadow-md flex flex-row content-center flex-wrap"
  >
    <div class="pt-2 basis-1/5 h-[32px]">
      <div v-if="props.showMenu" :class="menuClasses">
        <MenuComponent
          icon="bars"
          :primary-items="leftMenuItems"
          :secondary-items="leftSecondaryMenuItems"
        />
      </div>
    </div>
    <div class="flex justify-center items-center h-7 basis-3/5">
      <img class="h-[29px] filter-white" :src="settings.logo_url" />
    </div>
    <div
      v-if="props.showSignIn"
      class="flex justify-end items-center cursor-pointer basis-1/5 h-[32px]"
    >
      <div v-if="authStore.isAuthenticated" v-tooltip="customerStore.email" class="pt-1">
        <MenuComponent
          v-if="rightMenuItems.length > 0 || rightSecondaryMenuItems.length > 0"
          icon="circle-user"
          position="right"
          :primary-items="rightMenuItems"
          :secondary-items="rightSecondaryMenuItems"
        />
      </div>
      <div v-else class="flex justify-end items-center">
        <TwcLink :href="signInUrl" class="text-white !no-underline font-semibold mt-1">
          Sign in
        </TwcLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { TwcLink } from 'transit-web-components'
import MenuComponent from './MenuComponent.vue'
import { useAuthStore } from '@/stores/auth'
import { useSettingStore } from '@/stores/setting'
import { useCustomerStore } from '@/stores/customer'

const props = defineProps({
  showMenu: {
    type: Boolean,
    default: true
  },
  showSignIn: {
    type: Boolean,
    default: true
  },
  onlyMobile: {
    type: Boolean,
    default: false
  },
  leftMenuItems: {
    type: Array<MenuItem>,
    default: []
  },
  leftSecondaryMenuItems: {
    type: Array<MenuItem>,
    default: []
  },
  rightMenuItems: {
    type: Array<MenuItem>,
    default: []
  },
  rightSecondaryMenuItems: {
    type: Array<MenuItem>,
    default: []
  }
})

const settingStore = useSettingStore()
const authStore = useAuthStore()
const customerStore = useCustomerStore()
const { settings } = storeToRefs(settingStore)
const myBaseUrl = ref(import.meta.env.VITE_DOMAIN_MY)
const signInUrl = computed(() => `${myBaseUrl.value}/sign_in?redirect_to=${window.location}`)
const menuClasses = computed(() =>
  props.onlyMobile ? 'cursor-pointer md:hidden' : 'cursor-pointer'
)
</script>

<style scoped>
.filter-white {
  filter: brightness(0) invert(1) brightness(100%);
}
</style>
